import shortuuid from "short-uuid";

export function generateShortUuid(): string {
	return shortuuid(shortuuid.constants.uuid25Base36).generate();
}

export function convertShortUuidToUuid(shortUuid: string): string {
	return shortuuid(shortuuid.constants.uuid25Base36).toUUID(shortUuid);
}

export function convertUuidToShortUuid(uuid: string): string {
	return shortuuid(shortuuid.constants.uuid25Base36).fromUUID(uuid);
}

export const pageAuthorityId = (workspaceName: string, documentId: string, pageId: string) => {
	return `page/${workspaceName}/${documentId}/${pageId}`;
};

export const storeId = (workspaceName: string, documentId: string) => {
	return `doc/${workspaceName}/${documentId}`;
};

export const metadataStoreId = (workspaceName: string, documentId: string, branch: string) => {
	return `doc-metadata/${workspaceName}/${documentId}/${branch}`;
};
